import { render, staticRenderFns } from "./discoverAustraliaMobile.vue?vue&type=template&id=634c973b&scoped=true&"
import script from "./discoverAustraliaMobile.vue?vue&type=script&lang=js&"
export * from "./discoverAustraliaMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634c973b",
  null
  
)

export default component.exports